import { reducerWithInitialState } from "typescript-fsa-reducers";

import withImmer from "../../lib/withImmer";
import { bootstrapped, Experimenting } from "../actions/Experiments";

export type ExperimentName = ""; // Add experiment name like `| "foo_exp" | "bar_exp"`

export type ExperimentsState = { [key in ExperimentName]?: { variation: number } | null };

const initialState: ExperimentsState = {};

function buildState(experimentings: Experimenting[]): ExperimentsState {
  return experimentings.reduce(
    (acc, experimenting) => {
      acc[experimenting.experiment_name as ExperimentName] = { variation: experimenting.variation };
      return acc;
    },
    {} as ExperimentsState
  );
}

const experimentsReducer = withImmer(reducerWithInitialState(initialState)).case(
  bootstrapped,
  (state, { experimentings }) => {
    if (experimentings) {
      Object.assign(state, buildState(experimentings));
    }
    return state;
  }
);

export default experimentsReducer;



// WEBPACK FOOTER //
// ./frontend/src/common/reducers/experiments.ts